(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/differenceWith', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/differenceWith'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.differenceWith, global.convert);
    global.differenceWith = mod.exports;
  }
})(this, function (exports, _differenceWith2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.differenceWith = undefined;

  var _differenceWith3 = _interopRequireDefault(_differenceWith2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.difference} except that it uses <code>comparator</code> to compare elements of the former array to <code>values</code>.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} values The arrays of values to exclude.
   * @param {Function} [comparator] The comparator invoked per element.
   * @return {Object} Returns the updated object.
   * @example differenceWith({ nested: { prop: [{ x: 1 }, { x: 2 }] } }, 'nested.prop', [{ x: 2 }, { x: 3 }], (a, b) => a.x === b.x) // => { nested: { prop: [{ x: 1 }] } }
   * @see {@link https://lodash.com/docs#differenceWith|lodash.differenceWith} for more information.
   * @since 0.3.0
   */
  var differenceWith = (0, _convert.convert)(_differenceWith3.default);
  exports.differenceWith = differenceWith;
  exports.default = differenceWith;
});